export default "__VITE_ASSET__DQBAQY0X__"